// extracted by mini-css-extract-plugin
module.exports = {"linkqa":"enllac_linkqa__DdK9k"};